/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileTab/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProfileTab({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/ProfileTab"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalCurrentLocationPermissionsHasPatientProfileValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_profile',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(globalCurrentLocationPermissionsHasPatientProfileValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}